export const createApplicationApplicantFieldLengths = {
  bik: [9],
  settlementAccount: [20],
  correspondentAccount: [20],
  kpp: [9],
  inn: [10, 12],
  ogrn: [13, 15],
  oktmoOkato: [8, 10],
  okpo: [8, 10],
  snils: [11],
} as const;

const createApplicationApplicantSnilsMask = "000-000-000 00" as const;

const fixedDigitsMask = (length: number) => ({
  mask: "0".repeat(length),
});

const variableDigitsMask = (...lengths: number[]) => ({
  mask: lengths.map((length) => ({ mask: "0".repeat(length) })),
});

export const createApplicationApplicantInputMasks = {
  bik: fixedDigitsMask(createApplicationApplicantFieldLengths.bik[0]),
  settlementAccount: fixedDigitsMask(createApplicationApplicantFieldLengths.settlementAccount[0]),
  correspondentAccount: fixedDigitsMask(createApplicationApplicantFieldLengths.correspondentAccount[0]),
  kpp: fixedDigitsMask(createApplicationApplicantFieldLengths.kpp[0]),
  inn: variableDigitsMask(...createApplicationApplicantFieldLengths.inn),
  ogrn: variableDigitsMask(...createApplicationApplicantFieldLengths.ogrn),
  oktmoOkato: variableDigitsMask(...createApplicationApplicantFieldLengths.oktmoOkato),
  okpo: variableDigitsMask(...createApplicationApplicantFieldLengths.okpo),
  snils: { mask: createApplicationApplicantSnilsMask },
} as const;
